module.exports = __webpack_public_path__ + "NanumBarunGothic.eot";